// for reference: packages/nextjs-fullstack-application/node_modules/@deck.gl/layers/src/scatterplot-layer
import { PolygonLayer, PolygonLayerProps } from "@deck.gl/layers"
import type { DefaultProps } from "@deck.gl/core"
import { DataFilterExtension, DataFilterExtensionProps } from "@deck.gl/extensions"
import { Hotspot } from "@nova/protobuf"

type HotspotPolygonLayerDataType = Hotspot

type _HotspotPointsLayerProps = {
    getFilterValue: () => number
    filterRange?: [number, number]
}

type HotspotPointsLayerProps<DataType> = PolygonLayerProps<DataType> &
    _HotspotPointsLayerProps &
    DataFilterExtensionProps

const defaultProps: DefaultProps = {
    filled: true,
    opacity: 1,
    stroked: true,
    lineWidthMinPixels: 2,
    lineWidthMaxPixels: 2,
    extensions: [new DataFilterExtension({ filterSize: 1 })],
    filterRange: [1, 1],
    lineMiterLimit: 0,
}

export default class HotspotPolygonLayer<
    DataType = HotspotPolygonLayerDataType,
    ExtraPropsType extends object = HotspotPointsLayerProps<DataType>,
> extends PolygonLayer<DataType, ExtraPropsType> {
    static defaultProps = defaultProps
    static layerName = "HotspotPolygons"
}
